// extracted by mini-css-extract-plugin
export var author = "authors-details-module--author--OK1q6";
export var avatar = "authors-details-module--avatar--f3Ca-";
export var bottom = "authors-details-module--bottom--X4p7s";
export var details = "authors-details-module--details--JqVYG";
export var morebtn = "authors-details-module--morebtn--gFBzz";
export var name = "authors-details-module--name--4VAXS";
export var position = "authors-details-module--position--DET7T";